import { Alert, Button, Flex } from 'antd';

import { PROXY_LABEL } from '@app/constants/navigation';

import { IframePage } from '@pages/IframePage';

import {
  PROXY_ERROR_MESSAGES,
  PROXY_HANDSHAKE_TIMEOUT_DESCRIPTION,
  PROXY_HANDSHAKE_TIMEOUT_MESSAGE,
  PROXY_RETRY_LABEL,
} from '../constants';
import { useProxyIntegration } from '../hooks/useProxyIntegration';

import type { FC } from 'react';

export const ProxyIntegration: FC = () => {
  const {
    host,
    error,
    frameKey,
    isHandshakeTimedOut,
    messageHandler,
    retryHandler,
  } = useProxyIntegration();

  if (error) {
    return (
      <Alert type="error" showIcon message={PROXY_ERROR_MESSAGES[error]} />
    );
  }

  return (
    <Flex vertical gap="middle" flex={1}>
      {isHandshakeTimedOut && (
        <Alert
          type="warning"
          showIcon
          message={PROXY_HANDSHAKE_TIMEOUT_MESSAGE}
          description={PROXY_HANDSHAKE_TIMEOUT_DESCRIPTION}
          action={<Button onClick={retryHandler}>{PROXY_RETRY_LABEL}</Button>}
        />
      )}
      <IframePage
        key={frameKey}
        host={host}
        title={PROXY_LABEL}
        withJwt={false}
        withContextInUrl={false}
        isEmbedded
        onMessage={messageHandler}
      />
    </Flex>
  );
};
